import { useDispatch, useSelector } from "react-redux"
import { getTransaction } from "../store/features/transactionSlice"
import { Template } from "../components/Template"
import { findAllTransaction } from "../store/features/transactionSlice"
import { useEffect, useState } from "react"
import {
  Alert,
  Backdrop,
  Chip,
  CircularProgress,
  Divider,
  FormControl,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Paper,
  Select,
  TextField,
} from "@mui/material"
import { getAux } from "../store/features/auxSlice"
import { getConf } from "../store/features/confSlice"
import { TRANSACTION_MODEL } from "../constants"
import moment from "moment"
import { MyTable } from "../components/MyTable"
import { MyModal } from "../components/MyModal"
import PageviewOutlinedIcon from "@mui/icons-material/PageviewOutlined"
import FaceOutlinedIcon from "@mui/icons-material/FaceOutlined"
import CreditCardOutlinedIcon from "@mui/icons-material/CreditCardOutlined"
import SellOutlinedIcon from "@mui/icons-material/SellOutlined"
import VpnKeyOutlinedIcon from "@mui/icons-material/VpnKeyOutlined"
import ToggleOnOutlinedIcon from "@mui/icons-material/ToggleOnOutlined"
import LocalShippingOutlinedIcon from "@mui/icons-material/LocalShippingOutlined"
import ShoppingBagOutlinedIcon from "@mui/icons-material/ShoppingBagOutlined"
import AssignmentIndOutlinedIcon from "@mui/icons-material/AssignmentIndOutlined"
import EventAvailableOutlinedIcon from "@mui/icons-material/EventAvailableOutlined"
import { TransactionDetailTable } from "../components/tables/TransactionDetailTable"
import FlagOutlinedIcon from "@mui/icons-material/FlagOutlined"
import { IncomeForDayChart } from "../components/charts/transaction/IncomeForDayChart"
import { getAuth } from "../store/features/authSlice"

export const TransactionsScreen = () => {
  const transaction = useSelector(getTransaction)
  const aux = useSelector(getAux)
  const conf = useSelector(getConf)
  const auth = useSelector(getAuth)
  const [page, setPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(5)
  const dispatch = useDispatch()
  const [selected, setSelected] = useState({ ...TRANSACTION_MODEL })
  const [isOpen, setIsOpen] = useState(false)
  const [filters, setFilters] = useState({
    user: "",
    providerId: "",
    paymentMethod: "",
    cpeType: "%25",
    cpeSeries: "",
    cpeNumber: "",
    tracking: 2,
    state: 1,
    sinceDate: moment().format("YYYY-MM-DD"),
    untilDate: moment().format("YYYY-MM-DD"),
  })

  useEffect(() => {
    if (!!selected) {
      console.log(selected)
    }
  }, [selected])

  useEffect(() => {
    setPage(0)
    getAll()
  }, [filters])

  useEffect(() => {
    getAll()
  }, [page, rowsPerPage])

  const getAll = () => {
    dispatch(
      findAllTransaction({
        start: page,
        limit: rowsPerPage,
        user: filters.user,
        providerId: filters.providerId,
        paymentMethod: filters.paymentMethod,
        cpeType: filters.cpeType,
        cpeSeries: filters.cpeSeries,
        cpeNumber: filters.cpeNumber,
        tracking: filters.tracking,
        state: filters.state,
        sinceDate: filters.sinceDate,
        untilDate: filters.untilDate,
        jwt: auth.data.jwtToken,
      })
    )
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage)
  }

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value)
    setPage(0)
  }

  const selectItem = (row) => {
    setSelected(row)
    setIsOpen(true)
  }

  const handleClose = () => {
    setIsOpen(false)
    setSelected({ ...TRANSACTION_MODEL })
  }

  const handleChangeFilter = (e) => {
    const name = e.target.name
    const value = e.target.value
    setFilters({ ...filters, [name]: value })
  }

  const handleChangeElement = (e) => {
    setSelected({ ...selected, [e.target.name]: e.target.value })
  }

  const columns = [
    {
      field: "transactionType",
      headerName: "Tipo",
      width: 130,
      align: "left",
    },
    {
      field: "providerId",
      headerName: "Id Externo",
      width: 150,
      align: "left",
    },
    {
      field: "paymentMethod",
      headerName: "Método pago",
      width: 180,
      align: "left",
    },
    {
      field: "cpe",
      headerName: "CPE",
      width: 200,
      align: "left",
      render: (params) => (
        <span>
          {params.row.cpeSeries}-{params.row.cpeNumber}
        </span>
      ),
    },
    {
      field: "user",
      headerName: "Cliente",
      width: 400,
      align: "left",
      render: (params) => {
        const user = transaction.data.find(
          (item) => item.transaction.id === params.row.id
        ).user

        return (
          <>
            {user.personType === 1 && (
              <span>{user.name + " " + user.surname}</span>
            )}
            {user.personType === 2 && <span>{user.businessName}</span>}
          </>
        )
      },
    },
    {
      field: "total",
      headerName: "Importe",
      width: 250,
      align: "right",
      render: (params) => (
        <span style={{ color: params.row.total > 0 ? "green" : "red" }}>
          <span>
            {aux.data.coins.find((item) => item.id === params.row.coin).value}
          </span>{" "}
          <span>{params.row.total.toFixed(2)}</span>
        </span>
      ),
    },
    {
      field: "insertionDate",
      headerName: "Fecha de creación",
      width: 200,
      align: "left",
      render: (params) => (
        <span>
          {moment(params.row.insertionDate).format("YYYY-MM-DD, hh:mm:ss a")}
        </span>
      ),
    },
    {
      field: "",
      headerName: "Acciones",
      width: 90,
      align: "center",
      render: (params) => (
        <IconButton
          sx={{ cursor: "pointer" }}
          onClick={() => selectItem(params.row)}
        >
          <PageviewOutlinedIcon />
        </IconButton>
      ),
    },
  ]

  const modal = () => {
    if (!selected.id) return <div></div>

    return (
      <MyModal
        updateTitle={
          <span>
            <span>Detalles de la transacción:</span>{" "}
            <span style={{ color: "tan" }}>{selected.id}</span>{" "}
            <span style={{ color: "gray" }}>
              {selected.cpeSeries + " " + selected.cpeNumber}
            </span>
          </span>
        }
        insertTitle="No se permite crear transacciones por este canal"
        isOpen={isOpen}
        handleClose={handleClose}
        selected={selected}
      >
        <Grid container spacing={2}>
          <Grid item xs={12} my={2}>
            <Divider>
              <Chip label="Datos generales" />
            </Divider>
          </Grid>
          <Grid item xs={6}>
            <FormControl fullWidth>
              <InputLabel>Id interno</InputLabel>
              <OutlinedInput
                label="Id interno"
                name="id"
                value={selected.id}
                onChange={handleChangeElement}
                inputProps={{ readOnly: true }}
                startAdornment={
                  <InputAdornment position="start">
                    <VpnKeyOutlinedIcon />
                  </InputAdornment>
                }
              />
            </FormControl>
          </Grid>
          <Grid item xs={6}>
            <FormControl fullWidth>
              <InputLabel>Estado</InputLabel>
              <Select
                value={selected.state}
                label="Estado"
                name="state"
                onChange={handleChangeElement}
                inputProps={{ readOnly: true }}
                startAdornment={
                  <InputAdornment position="start">
                    <ToggleOnOutlinedIcon />
                  </InputAdornment>
                }
              >
                {aux.data.states.map((item) => (
                  <MenuItem key={item.id} value={item.id}>
                    {item.value}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} my={2}>
            <Divider>
              <Chip label="Datos de la transacción" />
            </Divider>
          </Grid>
          <Grid item xs={6}>
            <FormControl fullWidth>
              <InputLabel>Id externo</InputLabel>
              <OutlinedInput
                label="Id externo"
                name="providerId"
                value={selected.providerId}
                onChange={handleChangeElement}
                inputProps={{ readOnly: true }}
                startAdornment={
                  <InputAdornment position="start">
                    <VpnKeyOutlinedIcon />
                  </InputAdornment>
                }
              />
            </FormControl>
          </Grid>
          <Grid item xs={6}>
            <FormControl fullWidth>
              <InputLabel>Tipo de transacción</InputLabel>
              <OutlinedInput
                label="Tipo de transacción"
                name="transactionType"
                value={selected.transactionType}
                onChange={handleChangeElement}
                inputProps={{ readOnly: true }}
                startAdornment={
                  <InputAdornment position="start">
                    <ShoppingBagOutlinedIcon />
                  </InputAdornment>
                }
              />
            </FormControl>
          </Grid>
          <Grid item xs={6}>
            <FormControl fullWidth>
              <InputLabel>Método de pago</InputLabel>
              <OutlinedInput
                label="Método de pago"
                name="paymentMethod"
                value={selected.paymentMethod}
                onChange={handleChangeElement}
                inputProps={{ readOnly: true }}
                startAdornment={
                  <InputAdornment position="start">
                    <CreditCardOutlinedIcon />
                  </InputAdornment>
                }
              />
            </FormControl>
          </Grid>
          <Grid item xs={6}>
            <FormControl fullWidth>
              <InputLabel>Comprobante de pago</InputLabel>
              <OutlinedInput
                label="Comprobante de pago"
                name="cpe"
                value={selected.cpeSeries + "-" + selected.cpeNumber}
                onChange={handleChangeElement}
                inputProps={{ readOnly: true }}
                startAdornment={
                  <InputAdornment position="start">
                    <SellOutlinedIcon />
                  </InputAdornment>
                }
              />
            </FormControl>
          </Grid>
          <Grid item xs={6}>
            <FormControl fullWidth>
              <InputLabel>Importe</InputLabel>
              <OutlinedInput
                label="Importe"
                name="total"
                value={selected.total.toFixed(2)}
                onChange={handleChangeElement}
                inputProps={{ readOnly: true }}
                startAdornment={
                  <InputAdornment position="start">
                    <span
                      style={{
                        color: "gray",
                        fontWeight: 500,
                        fontSize: "1.3rem",
                      }}
                    >
                      {
                        aux.data.coins.find((item) => item.id === selected.coin)
                          .value
                      }
                    </span>
                  </InputAdornment>
                }
              />
            </FormControl>
          </Grid>
          <Grid item xs={6}>
            <FormControl fullWidth>
              <InputLabel>Tracking</InputLabel>
              <Select
                value={selected.tracking}
                label="Tracking"
                name="tracking"
                onChange={handleChangeElement}
                inputProps={{ readOnly: true }}
                startAdornment={
                  <InputAdornment position="start">
                    <LocalShippingOutlinedIcon />
                  </InputAdornment>
                }
              >
                {aux.data.tracking.map((item) => (
                  <MenuItem key={item.id} value={item.id}>
                    {item.value}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={6}>
            <FormControl fullWidth>
              <InputLabel>Fecha de creación</InputLabel>
              <OutlinedInput
                label="Fecha de creación"
                name="insertionDate"
                value={moment(selected.insertionDate).format(
                  "YYYY-MM-DD, hh:mm:ss a"
                )}
                onChange={handleChangeElement}
                inputProps={{ readOnly: true }}
                startAdornment={
                  <InputAdornment position="start">
                    <EventAvailableOutlinedIcon />
                  </InputAdornment>
                }
              />
            </FormControl>
          </Grid>
          <Grid item xs={12} my={2}>
            <Divider>
              <Chip label="Detalle de la transacción" />
            </Divider>
          </Grid>
          <Grid item xs={12}>
            {!!selected.id && (
              <TransactionDetailTable
                transaction={transaction.data.find(
                  (item) => item.transaction.id === selected.id
                )}
              />
            )}
          </Grid>
          <Grid item xs={12} my={2}>
            <Divider>
              <Chip label="Datos del cliente" />
            </Divider>
          </Grid>
          <Grid item xs={6}>
            <FormControl fullWidth>
              <InputLabel>Id de cliente</InputLabel>
              <OutlinedInput
                label="Id de cliente"
                name="id"
                value={selected.user}
                onChange={handleChangeElement}
                inputProps={{ readOnly: true }}
                startAdornment={
                  <InputAdornment position="start">
                    <AssignmentIndOutlinedIcon />
                  </InputAdornment>
                }
              />
            </FormControl>
          </Grid>
          <Grid item xs={6}>
            <FormControl fullWidth>
              <InputLabel>Nombre</InputLabel>
              <OutlinedInput
                label="Nombre"
                name="userName"
                value={(() => {
                  const user = transaction.data.find(
                    (item) => item.transaction.id === selected.id
                  ).user
                  return user.personType === 1
                    ? user.name + " " + user.surname
                    : user.businessName
                })()}
                onChange={handleChangeElement}
                inputProps={{ readOnly: true }}
                startAdornment={
                  <InputAdornment position="start">
                    <FaceOutlinedIcon />
                  </InputAdornment>
                }
              />
            </FormControl>
          </Grid>
          <Grid item xs={6}>
            <FormControl fullWidth>
              <InputLabel>Capítulo</InputLabel>
              <OutlinedInput
                label="Capítulo"
                name="chapter"
                value={(() => {
                  const user = transaction.data.find(
                    (item) => item.transaction.id === selected.id
                  ).user
                  return conf.data.chapters.find(
                    (item) => item.id === user.chapter
                  ).name
                })()}
                onChange={handleChangeElement}
                inputProps={{ readOnly: true }}
                startAdornment={
                  <InputAdornment position="start">
                    <FlagOutlinedIcon />
                  </InputAdornment>
                }
              />
            </FormControl>
          </Grid>
          <Grid item xs={12} my={2}>
            <Divider>
              <Chip label="Datos para el desarrollador" />
            </Divider>
          </Grid>
          <Grid item xs={12}>
            <TextField
              multiline
              label="Payload"
              variant="outlined"
              fullWidth
              name="payload"
              value={selected.payload}
              onChange={handleChangeElement}
              inputProps={{ readOnly: true }}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              multiline
              label="Response"
              variant="outlined"
              fullWidth
              name="response"
              value={selected.response}
              onChange={handleChangeElement}
              inputProps={{ readOnly: true }}
            />
          </Grid>
        </Grid>
      </MyModal>
    )
  }

  return (
    <Template>
      {!!selected && modal()}
      <Grid item xs={12}>
        <Paper
          sx={{
            p: 2,
            display: "flex",
            flexDirection: "column",
          }}
        >
          <IncomeForDayChart />
        </Paper>
      </Grid>
      <Grid item xs={12}>
        <Paper sx={{ p: 2, display: "flex", flexDirection: "column" }}>
          <Grid
            container
            spacing={2}
            sx={{ paddingY: 2 }}
            direction="row"
            justifyContent="space-between"
            alignItems="center"
          >
            <Grid item xs={10}>
              <TextField
                sx={{ marginRight: 1 }}
                label="Cliente"
                variant="outlined"
                name="user"
                value={filters.user}
                onChange={handleChangeFilter}
              />
              <TextField
                sx={{ marginRight: 1 }}
                label="Id externo"
                variant="outlined"
                name="providerId"
                value={filters.providerId}
                onChange={handleChangeFilter}
              />
              <TextField
                sx={{ marginRight: 1 }}
                label="Método de pago"
                variant="outlined"
                name="paymentMethod"
                value={filters.paymentMethod}
                onChange={handleChangeFilter}
              />
            </Grid>
            <Grid item xs={10}>
              <FormControl sx={{ marginRight: 1 }}>
                <InputLabel>Tipo CPE</InputLabel>
                <Select
                  value={filters.cpeType}
                  label="Tipo CPE"
                  name="cpeType"
                  onChange={handleChangeFilter}
                >
                  <MenuItem value="%25">Todos</MenuItem>
                  <MenuItem value="B">Boleta</MenuItem>
                  <MenuItem value="F">Factura</MenuItem>
                </Select>
              </FormControl>
              <TextField
                sx={{ marginRight: 1 }}
                label="N° CPE"
                variant="outlined"
                name="cpeNumber"
                value={filters.cpeNumber}
                onChange={handleChangeFilter}
              />
              <FormControl sx={{ marginRight: 1 }}>
                <InputLabel>Tracking</InputLabel>
                <Select
                  value={filters.tracking}
                  label="Tracking"
                  name="tracking"
                  onChange={handleChangeFilter}
                >
                  {aux.data.tracking.map((item) => (
                    <MenuItem key={item.id} value={item.id}>
                      {item.value}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <FormControl sx={{ marginRight: 1 }}>
                <InputLabel>Estado</InputLabel>
                <Select
                  value={filters.state}
                  label="Estado"
                  name="state"
                  onChange={handleChangeFilter}
                >
                  {aux.data.states.map((item) => (
                    <MenuItem key={item.id} value={item.id}>
                      {item.value}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <div style={{ marginLeft: 1 }}></div>
          </Grid>
          {transaction.status === "loading" && (
            <Backdrop
              sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
              open={transaction.status === "loading"}
            >
              <CircularProgress color="inherit" />
            </Backdrop>
          )}
          {transaction.status === "failed" && (
            <Alert severity="error">{String(transaction.error)}</Alert>
          )}
          {transaction.status === "succeeded" && (
            <div style={{ minHeight: 400, width: "100%" }}>
              <MyTable
                columns={columns}
                rows={transaction.data.map((item) => item.transaction)}
                page={page}
                handleChangePage={handleChangePage}
                rowsPerPage={rowsPerPage}
                handleChangeRowsPerPage={handleChangeRowsPerPage}
                totalElements={transaction.totalElements}
              />
            </div>
          )}
        </Paper>
      </Grid>
    </Template>
  )
}
